export default "__VITE_ASSET__b701812c__"